/**
 * Global leaderboard client (Workstream D). Talks to the same-origin Pages Function
 * (/api/leaderboard/*) backed by Cloudflare D1. Every call FAILS SILENT: if the store is not
 * provisioned (503) or the network is down, submit is a no-op and fetchTop returns []. The UI
 * then degrades to "no scores yet", so the game never depends on the backend being enabled.
 */
export type LeaderboardEntry = { name: string; score: number };

export const ENDLESS_BOARD = "endless";

export function dailyBoardKey(dateKey: string): string {
  return `daily:${dateKey}`;
}

/** Fire-and-forget score submission. Resolves true only on a confirmed 200 OK. */
export async function submitScore(board: string, name: string, score: number, playerId?: string): Promise<boolean> {
  try {
    const res = await fetch("/api/leaderboard/submit", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ board, name, score, playerId })
    });
    return res.ok;
  } catch {
    return false;
  }
}

/** Fetch the top entries for a board. Returns [] on any error / when unconfigured. */
export async function fetchTop(board: string, limit = 20): Promise<LeaderboardEntry[]> {
  try {
    const res = await fetch(`/api/leaderboard/top?board=${encodeURIComponent(board)}&limit=${limit}`);
    if (!res.ok) return [];
    const data = (await res.json()) as { ok?: boolean; entries?: LeaderboardEntry[] };
    if (!data.ok || !Array.isArray(data.entries)) return [];
    return data.entries
      .filter((e) => e && typeof e.name === "string" && Number.isFinite(e.score))
      .map((e) => ({ name: e.name, score: Math.round(e.score) }));
  } catch {
    return [];
  }
}
